import { Icon } from "@iconify/react";
import { Colors } from "../utils/colors";
import { CircularProgress } from "@mui/material";
import { ReactNode } from "react";

type DropdownMenuLabelProps = {
  label: string;
  subtext?: ReactNode;
  icon?: string;
  iconColor?: string;
  width?: number;
  isDestructive?: boolean;
  labelColor?: string;
  loading?: boolean;
  dark?: boolean;
  disabled?: boolean;
};

const DropdownMenuLabel = (props: DropdownMenuLabelProps) => {
  const {
    label,
    subtext,
    icon,
    iconColor,
    width,
    isDestructive = false,
    labelColor,
    loading = false,
    dark = false,
    disabled = false,
  } = props;

  return (
    <div
      className="AlignedRowSpacedSelect"
      style={{
        width: width,
        paddingBlock: 4,
        transition: "opacity 0.2s ease",
        pointerEvents: disabled ? "none" : "all",
        opacity: disabled ? 0.4 : 1,
      }}
      onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")}
      onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
    >
      <div className="ColumnNormal">
        <span
          style={{
            fontWeight: 500,
            color: isDestructive
              ? Colors.RED1
              : labelColor !== undefined
              ? labelColor
              : dark
              ? Colors.WHITE
              : Colors.BLACK,
          }}
        >
          {label}
        </span>
        {subtext}
      </div>
      {icon ? (
        loading ? (
          <CircularProgress
            style={{
              color: dark ? Colors.WHITE : Colors.BLACK,
              alignSelf: "center",
            }}
            size={17}
          />
        ) : (
          <Icon
            icon={icon}
            height={16}
            style={{
              color: isDestructive
                ? Colors.RED1
                : iconColor !== undefined
                ? iconColor
                : labelColor !== undefined
                ? labelColor
                : dark
                ? Colors.WHITE
                : Colors.BLACK,
            }}
          />
        )
      ) : null}
    </div>
  );
};

export default DropdownMenuLabel;
